import React from 'react';
import { Box, Typography, Stepper, Step, StepLabel } from '@mui/material';
import {
  StyledSidebar,
  DecorativeCircle,
  SidebarContent,
  ProgressBar,
  ProgressIndicator,
} from '../../../core/components/styled/StyledComponents';
import { ENROLLMENT_FORM_STEPS } from '../../../core/constant/constant';

interface Options {
  title: string;
  key: string;
}
interface FormSidebarProps {
  activeStep: number;
  getProgressValue: () => number;
  options: Options[],
  title: string;
  description: string;
  hideProgress?: boolean;
}

const FormSidebar: React.FC<FormSidebarProps> = ({ activeStep, getProgressValue, options, title, description, hideProgress }) => {
  return (
    <StyledSidebar>
      <DecorativeCircle
        sx={{
          width: '300px',
          height: '300px',
          top: '-100px',
          right: '-150px',
        }}
      />
      <DecorativeCircle
        sx={{
          width: '200px',
          height: '200px',
          bottom: '80px',
          left: '-120px',
        }}
      />

      <SidebarContent>
        <Box>
          <Typography variant='h4' sx={{ mb: 1, fontWeight: 500 }}>
            {title}
          </Typography>
          <Typography variant='body1' sx={{ opacity: 0.9, mb: 0.5 }}>
            {description}
          </Typography>


          <Box sx={{ mb: 3 }}>
            {!hideProgress && <>
              <Typography variant='body1' sx={{ opacity: 0.9, mb: 5 }}>
                in just {ENROLLMENT_FORM_STEPS.length} steps
              </Typography>
              <ProgressBar>
                <ProgressIndicator value={getProgressValue()} />
              </ProgressBar>
              <Typography variant='body2' sx={{ opacity: 0.8 }}>
                Step {activeStep + 1} of {ENROLLMENT_FORM_STEPS.length}
              </Typography>
            </>}
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Stepper
              activeStep={activeStep}
              orientation='vertical'
              sx={{
                '.MuiStepLabel-label': { color: 'white' },
                '.MuiStepIcon-root': { color: 'rgba(255,255,255,0.5)' },
                '.MuiStepIcon-root.Mui-active': { color: 'white' },
                '.MuiStepIcon-root.Mui-completed': { color: 'white' },
                '.MuiStepConnector-line': { borderColor: 'rgba(255,255,255,0.3)' },
              }}
            >
              {options.map((step, index) => {
                return (
                  <Step key={step.key}>
                    <StepLabel
                      slotProps={{
                        stepIcon: {
                          sx: {
                            '&.Mui-completed': {
                              color: 'white !important',
                              backgroundColor: 'transparent',
                              zIndex: 1,
                            },
                          },
                        },
                      }}
                    >
                      <Typography
                        variant='body2'
                        sx={{
                          color:
                            index < activeStep
                              ? 'white'
                              : index === activeStep
                                ? 'white'
                                : 'rgba(255,255,255,0.7)',
                          fontWeight: index === activeStep ? 600 : 400,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                        }}
                      >
                        {step.title}
                      </Typography>
                    </StepLabel>
                  </Step>
                )
              })}
            </Stepper>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1 }}></Box>
      </SidebarContent>
    </StyledSidebar>
  );
};

export default FormSidebar;
